/**
 *
 */
(function () {
  let trackWrapper = document.querySelectorAll('.info')[0];

  if (!trackWrapper || !trackWrapper.dataset || !trackWrapper.dataset.trackurl) {
    return;
  }

  let trackInfo = {
    id: trackWrapper.dataset.trackid,
    src: trackWrapper.dataset.trackurl,
    artist: trackWrapper.getElementsByClassName("artist").length > 0 ? trackWrapper.getElementsByClassName("artist")[0].innerHTML : '',
    title: trackWrapper.getElementsByClassName("title").length > 0 ? trackWrapper.getElementsByClassName("title")[0].innerHTML : ''
  };

  // Player
	let player;
	document.addEventListener("DOMContentLoaded", function() {
		player = new document.NaïvePlayer('audio-player');
    player._updateBar(0);
  });

  // Callback
  let callback = function () {
    // If we're playing the same track as the one just clicked, pause.
    // Otherwise play.
    if (player.player.src && player.player.src == trackInfo.src) {
      player.playPause();
    }
    else {
      player.addToQueue( [trackInfo] );
      player.next();
    }
  };

  // Attach callbasck to buttons
  let button = document.querySelectorAll('.play');
  for (let j = 0; j < button.length; ++j) {
    button[j].onclick = callback;
  }
}());
